/**设置**/
<template>
  <div class="settings">
    <div class="page1 page">
      <ul class="pageItme">
        <li>
          <router-link :to="'/servicePrice'">
            服务价格
            <i class="iconfont icon-jiantou"></i>
          </router-link>
        </li>
        <li>
          <router-link :to="'/serviceAgreement'">
            服务协议
            <i class="iconfont icon-jiantou"></i>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="page2 page">
      <ul class="pageItme">
        <li>
          服务热线
          <span><a
            :href="'tel:'+ (infoData.companyinfo?infoData.companyinfo.telephone:'')">{{infoData.companyinfo ? infoData.companyinfo.telephone : ''}}</a></span>
        </li>
        <li>
          当前版本
          <span>V5.1.12.003</span>
        </li>
      </ul>
    </div>
    <div class="logoutBut">
      <span class="But" @click='BoxLogoutFn("show")'>
        注销账户
      </span>
    </div>
    <div class="modelBox BoxLogout" :class="{'showModelBox':BoxLogout}">
      <div class="Box">
        <div class="modelBoxContent">
        <span class="Icon">
          <i class="iconfont icon-yy03 "></i>
        </span>
          <p class="text">你确定要注销吗？</p>
        </div>
        <div class="modelBoxBottom clear">
          <span class="ActionBut NoBut" @click="BoxLogoutFn('on')">留下</span>
          <span class="ActionBut OKBut" @click="BoxLogoutFn('ok')">确认</span>
        </div>
      </div>
      <div class="modelBoxModel" v-if="BoxLogout">
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import cookieJS from 'js-cookie'

  export default {
    name: 'settings',
    data () {
      return {
        BoxLogout: false
      }
    },
    computed: {
      ...mapGetters({
        infoData: 'infoData',
        servesTypeNav: 'servesTypeNav',
        positioning: 'positioning',
        loginData: 'loginData'
      })
    },
    methods: {
      BoxLogoutFn: function (e) {
        let that = this
        switch (e) {
          case 'ok':
            that.BoxLogout = false
            this.loginOutFn()
            // that.$store.dispatch('logoutUser', {
            //   fn: (state) => {
            //     if (state) {
            //       // that.$store.dispatch('ZcQueryCar', {
            //       //   lat: that.positioning.lat ? that.positioning.lat : '',
            //       //   lng: that.positioning.lng ? that.positioning.lng : ''
            //       // })
            //       // that.$store.dispatch('HyQueryCarType', {
            //       //   'companyId': that.loginData.passenger && that.loginData.passenger.companyId ? that.loginData.passenger.companyId : that.infoData.companyInfo.data.companyId
            //       // })
            //       that.$router.push(that.servesTypeNav[0].url)
            //     }
            //   }
            // })
            break
          case 'on':
            that.BoxLogout = false
            break
          case 'show':
            that.BoxLogout = true
            break
        }
      },
      /**
       * 注销登录的接口
       **/
      async loginOutFn () {
        let id = window.configure.passengerInfo.id
        let url = '/v1/loginOut'
        let params = {
          id: id, // 客户id
          app_key: window.configure.appKey,
          channel: 'weixin'
        }
        let data = await this.$axios.post(url, params)
        if (data && data.code === 1) {
          // 注销成功回到首页
          let passengerkey = window.configure.passengerKey
          let passanger = cookieJS.get(passengerkey)
          console.log('注销成功回到首页', passanger)
          if (passanger) {
            cookieJS.remove(passengerkey)
          }
          this.$store.dispatch('loginAction', {state: false})
          this.$router.push('/')
        }
      }
    },
    mounted: function () {
      this.$store.dispatch('checkLogin')
      console.log(this.infoData)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .settings {
    width: 100vw;
    height: 100vh;
    background-color: #f3f4f5;
    .page {
      padding-top: 1rem;
      .pageItme {
        background-color: #fff;
      }
      li {
        box-sizing: border-box;
        padding: 0 1rem;
        margin: 0 1rem;
        border-bottom: 1px solid #f3f4f5;
        height: 3.666666rem;
        line-height: 3.666666rem;
        font-size: 1rem;
        a {
          color: #333333;
          width: 100%;
        }
        i {
          float: right;
          line-height: 3.666666rem;
          font-size: 1rem;
          color: #999999;
        }
        span {
          float: right;
          color: #999999;
        }
      }
      li:nth-last-child(1) {
        border-bottom: none;
      }
    }
    .logoutBut {
      padding: 0 1rem;
      margin-top: 1rem;
      .But, a {
        width: 100%;
        height: 3.666666rem;
        line-height: 3.666666rem;
        color: #fff;
        background-color: #f06553;
        border-radius: 0.5rem;
        text-align: center;
        font-size: 1rem;
      }
    }
    .modelBox {
      .modelBoxContent {
        text-align: center;
        .Icon {
          width: 4.08333rem;
          height: 4.08333rem;
          overflow: hidden;
          border-radius: 50%;
          background-color: #f3f4f5;
          position: relative;
          i {
            position: absolute;
            font-size: 1.8rem;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            color: #999999;
          }
        }
        .text {
          font-size: 1rem;
          color: #333333;
          margin-top: 0.8rem;
        }
      }
    }
    .showModelBox {
      .Box {
        opacity: 1;
        z-index: 100;
        .NoBut {
          border-radius: 0 0 0 0 !important;
        }
        .OKBut {
          border-radius: 0 0 0 0 !important;
        }
      }
      .modelBoxModel {
        z-index: 50;
        opacity: 1;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// settings.vue?1ad85ad7